<template>
  <div class="panel-body" :style="height">
    <table :id="id" class="table">
      <thead>
        <tr class="text-center">
          <th v-for="(val, key, index) in names" :id="id + '-name-' + key" :key="key">
            {{ val.name }}
            <i v-show="val.icon" class="fa" aria-hidden="true" :class="val.icon"></i>
          </th>
        </tr>
      </thead>
      <tbody v-for="(row, key, index) in data" :id="id + '-body'" :key="key">
        <tr class="info">
          <td v-for="(r, k, i) in row" :id="id + '-body-' + k" :key="k" v-if="k !== 'id'">  <!-- if theres an ID key it wont be shown -->
            <div>
              <p v-if="k !== 'alarmaAsignada'"> {{ r }} </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

/*
NAMES:
alarmFields: {
        'f1': {  // data with icon
          name: 'Fecha',
          icon: 'fa-angle-down'
        },
        'f2': { // just a name
          name: 'Concepto',
        }
      },
*/

/**
 *  DATA
 bitacora: [
        {
          id: 1,
          fecha: '10/07/2017',
          concepto: 'toluca-df',
          ducto: 23,
          usuario: 320,
          comentario: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis placeat sit, praesentium harum laborum dolorem minus quo aliquam fugit dolore dolorum facere adipisci repellendus dolores in omnis recusandae quasi impedit?',
          alarmaAsignada: {  <-- este nombre no es forzoso
            iconOnly: false,    <-- todos los nombres dentro del objeto son forzosos
            status: true,
            text: 'No Alarma',
            icon: 'warning',
            istyle: 'color: red; display: block',
            pstyle: ''
          }
        },
        {
          id: 2,
          fecha: '10/07/2017',
          concepto: 'mexicali-tijuana',
          ducto: 45,
          usuario: 250,
          comentario: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis placeat sit, praesentium harum laborum dolorem minus quo aliquam fugit dolore dolorum facere adipisci repellendus dolores in omnis recusandae quasi impedit?',

        },
      ]
 */

export default {
  props: ['data', 'names', 'id', 'modalTarget', 'height']
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.row {
  margin: 0;
  padding: 0;
}

table,
.panel-body {
  background-color: $bg;
  overflow: scroll;
  // height: 55vh;
  padding: 0;
}

.panel-default {
  background-color: $gray;
  border: none;
  border-radius: 0;
}

table{
  thead {
    tr {
      th {
        color: white;
        background-color: $amarilloC;
      }
    }
  }
  th {
    text-align: left;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  tbody {
    td {
      text-align: left;
      background-color: $bg !important;
      max-width: 700px;
      p {
        font-size: 12px;
      }
      i {
        color: $inactive;
        cursor: pointer;
        &:hover {
          color: $amarilloC;
        }
      }
    }
  }
  .table-name {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding-right: -15px;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SingleTable.vue?46f1fbc0